<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.4999 10.9998H3V6.49976" stroke="inherit" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.5 2H11.9999V6.50007" stroke="inherit" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
